import { render } from "./PartnerCategoriesView.vue?vue&type=template&id=4ea4851b"
import script from "./PartnerCategoriesView.vue?vue&type=script&lang=js"
export * from "./PartnerCategoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__